import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fefce8',
      100: '#fef9c3',
      200: '#fef08a',
      300: '#fde047',
      400: '#facc15',
      500: '#eab308',
      600: '#ca8a04',
      700: '#a16207',
      800: '#854d0e',
      900: '#713f12',
      950: '#422006',
    },
  },
  components: {
    inputtext: {
      root: {
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        focusBorderColor: 'transparent',
      },
    },
    button: {
      root: {
        borderRadius: '9999px',
      },
      colorScheme: {
        dark: {
          root: {
            primary: {
              background: '{primary.400}',
              color: '#000000', // Černý text
              hoverBackground: '{primary.300}',
              activeBackground: '{primary.500}',
            },
            secondary: {
              background: '#ffffff',
              color: '#000000',
              hoverBackground: '#f4f4f5',
              activeBackground: '#e4e4e7',
            },
            contrast: {
              background: '{surface.700}',
              color: '#ffffff',
              hoverBackground: '{surface.600}',
            },
          },
        },
      },
    },
  },
});

export default MyTheme;
